import { useMemo } from 'react';

import { useBooleanFlags } from '@/domains/core/flags/flags.hooks';

import { ABTests } from '../../AddToWishlist/abTests';
import { wishlistsService } from '../wishlistsService';

export const useWishlistServices = () => {
  const [isWishlistRevampEnabled] = useBooleanFlags([
    ABTests.WISHLIST_REVAMP_ENABLED,
  ]);
  const { calls, names } = useMemo(
    () => wishlistsService(isWishlistRevampEnabled),
    [isWishlistRevampEnabled],
  );
  return useMemo(() => ({ calls, names }), [calls, names]);
};
